import React from "react";
import { motion } from "framer-motion";
import { FaTools, FaPaintRoller, FaWrench, FaTruck, FaIndustry, FaHardHat, FaCheck } from "react-icons/fa";
import SectionHeading from "../SectionHeading";

function PlantAndMachinery() {
  const plantAndMachinery = [
    {
      category: "Scaffolding Tools",
      icon: <FaTools aria-hidden="true" />,
      items: [
        { name: "M.S Pipes" },
        { name: "M.S. Couplock" },
        { name: "M.S Platform" },
        { name: "H-Frame" },
        { name: "Bamboo" },
        { name: "Electrical Operated 0.5MT capacity Lift" },
      ],
    },
    {
      category: "Coating Equipments",
      icon: <FaPaintRoller aria-hidden="true" />,
      items: [
        { name: "Airless Spray Coating" },
        { name: "Sand Blasting Hopper & Guniting" },
        { name: "Digital coat meter" },
        { name: "Jet water pump" },
      ],
    },
    {
      category: "Repair & Rehabilitation",
      icon: <FaWrench aria-hidden="true" />,
      items: [
        { name: "Hydraulic Pre-stressing Jacks" },
        { name: "Mobile Gantry for Repair of Bridges" },
        { name: "Drilling & Grouting Equipments" },
        { name: "Guniting Equipment / Brush Coating" },
        { name: "Breaking Equipments" },
        { name: "Rock Breaker" },
        { name: "Light electric chipper" },
      ],
    },
    {
      category: "Transportation",
      icon: <FaTruck aria-hidden="true" />,
      items: [
        { name: "Eicher Tempo - 19 Feet" },
        { name: "Pickup - 1 Nos" },
      ],
    },
    {
      category: "Concrete Equipments",
      icon: <FaIndustry aria-hidden="true" />,
      items: [
        { name: "Concrete Mixers" },
        { name: "Shuttering (1800 Sqm)" },
        { name: "Steel Props" },
        { name: "Vibrators" },
        { name: "Sintex Tanks" },
      ],
    },
    {
      category: "Power & Fabrication",
      icon: <FaHardHat aria-hidden="true" />,
      items: [
        { name: "Diesel Power Generator Sets" },
        { name: "Diesel Welding Generator" },
        { name: "Field Hydraulic Testing Kits" },
        { name: "Hydraulic Testing Machinery" },
        { name: "Welding Machine Arch/Argon" },
        { name: "Mother Oven" },
        { name: "Portable Oven" },
        { name: "AG4 / AG5 Grinding Machine" },
        { name: "DP Set" },
      ],
    },
  ];

  return (
    <section id="plant-machinery" className="scroll-mt-36 py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Our Equipment" title="Plant & Machinery" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
          {plantAndMachinery.map((category, categoryIndex) => (
            <motion.article
              key={category.category}
              className="flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-6 shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-brand-yellow hover:shadow-xl"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (categoryIndex % 3) * 0.08 }}
            >
              <div className="flex items-center gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-navy text-xl text-brand-yellow">
                  {category.icon}
                </span>
                <h3 className="flex-1 text-lg font-bold text-brand-navy">{category.category}</h3>
                <span
                  className="rounded-full bg-brand-yellow px-2.5 py-0.5 text-xs font-bold text-brand-navy"
                  title={`${category.items.length} items`}
                >
                  {category.items.length}
                </span>
              </div>
              <ul className="mt-5 space-y-2 border-t border-gray-100 pt-4">
                {category.items.map((item) => (
                  <li key={item.name} className="flex items-start gap-2.5 text-gray-700">
                    <FaCheck className="mt-1 shrink-0 text-xs text-brand-navy-light" aria-hidden="true" />
                    <span>{item.name}</span>
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PlantAndMachinery;
